function FitCheckLoading() {
	return (
		<div className="flex flex-col items-center justify-center gap-4 px-5 py-16 text-center">
			<div className="h-9 w-9 animate-spin rounded-full border-[3px] border-gray-200 border-t-primary-700" />
			<div className="font-inter">
				<p className="text-[15px] font-semibold text-gray-900">Reading your CV against this role</p>
				<p className="mt-1 text-sm text-gray-600">Matching each requirement, one by one.</p>
			</div>
		</div>
	);
}

export default FitCheckLoading;
